import type { ComponentType } from 'react'
import {
  UserOutlined,
  TeamOutlined,
  EnvironmentOutlined,
  AlertOutlined,
  ShareAltOutlined,
  IdcardOutlined,
} from '@ant-design/icons'
import { ROSTER_CATEGORIES } from '@sportninja/common/features/team/player'
import type { ScrollSpyItem } from 'src/components/ScrollSpyLayout'

const CATEGORY_ICONS: Record<string, ComponentType> = {
  personal: UserOutlined,
  rosterInfo: TeamOutlined,
  address: EnvironmentOutlined,
  emergencyContact: AlertOutlined,
  socialProfiles: ShareAltOutlined,
  membership: IdcardOutlined,
}

export const ROSTER_PLAYER_SETUP_ITEMS: ScrollSpyItem[] = ROSTER_CATEGORIES.map(
  (cat) => ({
    key: cat.key,
    label: cat.label,
    icon: CATEGORY_ICONS[cat.key] ?? UserOutlined,
  })
)
